import useSWR from "swr";
import { customFetcher, notify } from "../../../../utils";
import VirtualTable from "../../../custom/VirtualTable";
import { Printer } from "../../../../globals/interfaces";
import useUser from "../../../../customHooks/useUser";
import useAppData from "../../../../customHooks/useAppData";
import { useState } from "react";
import apiClient from "../../../../apiClient";
import useModal from "../../../../customHooks/useModal";
import ModalManagePrinters from './ModalManagePrinters';
import styled from "styled-components";
import ActionIcon from "../../../custom/ActionIcon";

const ENDPOINT = '/printer';

export default function ManagePrinters({
    activeTabId
}: {
    activeTabId: string;
}) {

    const { user } = useUser();
    const { s_email, s_unit: unit } = user;
    const { stations } = useAppData();
    const units = stations.map(item => ({ label: item.s_unit, value: item.s_unit }));

    const key = activeTabId === 'printers' ? ENDPOINT : null;

    const {
        data,
        mutate
    } = useSWR(key, customFetcher<Printer>, {
        fallbackData: []
    })

    const [id, setId] = useState<number>();
    const printer = data.find(item => item.id === id);

    const createUpdateItem = async (data: Printer, update?: boolean) => {
        try {
            const method = update ? 'put' : 'post';
            await apiClient[method](ENDPOINT, data);
            mutate();
            setModal(false);
            notify('Success');
        } catch (err) {
            alert(err);
        }
    }

    const deleteItem = async (id: number) => {
        try {
            await apiClient.delete(`${ENDPOINT}/${id}`);
            setModal(false);
            notify('Deleted');
            mutate();
        } catch (err) {
            alert(err);
        }
    }

    const { modal, setModal } = useModal();

    const handleLaunchModal = (id?: number) => {
        setId(id || undefined);
        setModal(true);
    }

    return (
        <div>
            <FlexContainer>
                <ActionIcon type={'add'} onClick={handleLaunchModal} />
            </FlexContainer>
            <VirtualTable<Printer>
                data={data}
                mapping={[{
                    name: 'Name',
                    value: 'name'
                }, {
                    name: 'IP Address',
                    value: 'ipAddress'
                }, {
                    name: 'Unit',
                    value: 'unit'
                }, {
                    name: 'Created by',
                    value: 'createdBy',
                    email: true
                }, {
                    name: 'Created at',
                    value: 'createdAt',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Modified by',
                    value: 'createdBy',
                    email: true
                }, {
                    name: 'Modified at',
                    value: 'modifiedAt',
                    datetime: true,
                    utc: true
                }]}
                handleClick={item => handleLaunchModal(item.id)}
            />
            <ModalManagePrinters
                modal={modal}
                setModal={setModal}
                s_email={s_email}
                units={units}
                onSubmit={createUpdateItem}
                deleteItem={deleteItem}
                printer={printer}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
`;